module.exports = __webpack_public_path__ + "assets/images/icons/icon_check-green.svg?v=1b64f32b";